var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-item',{attrs:{"label":_vm.$t('image_cutout'),"keybind":"shift+M"},model:{value:(_vm.module.showWindow),callback:function ($$v) {_vm.$set(_vm.module, "showWindow", $$v)},expression:"module.showWindow"}})}
var staticRenderFns = []

export { render, staticRenderFns }